// extracted by mini-css-extract-plugin
export default {"details":"details__tqYOZ","content":"content__KsQji","icon":"icon__z5KO1"};